/**
 * Pull a 4-digit year from any of our flexible date strings
 * ("1887", "14-03-1887", "circa 1890", "1887-06-15", "1887-06", etc).
 * Returns the year as a string or null.
 */
export function extractYear(dateStr) {
  if (!dateStr) return null
  const m = String(dateStr).match(/\d{4}/)
  return m ? m[0] : null
}
